import { produce } from "immer";
import { kDefaultExclusiveBrand } from "./defaultData";
import { tExclusiveBrandAction, tExclusiveBrandState } from "./types";

export const ExclusiveBrandReducer = produce(
  (state: tExclusiveBrandState = kDefaultExclusiveBrand, action: tExclusiveBrandAction): tExclusiveBrandState => {
    switch (action.type) {
      case "EXCLUSIVE_BRANDS":
        state.brands = action.data;
        return state;
      default:
        return state;
    }
  },
);
